/**
 * Checks if a URL points to the local website or to an external address.
 * Compares against the site's domain rather than the browser's location, so
 * server rendering gives the same answer as the browser.
 * @param url
 */
export default function isExternalUrl(url: string): boolean {
    const isLocalUri = url.match(/^https?:\/\//) === null;
    if (isLocalUri) {
        return false;
    }
    const urlObj = new URL(url);
    return urlObj.host !== process.env.GATSBY_STATIC_SITE_DOMAIN;
}
